'use client';

import { useSocket } from '@/stores/context/socketProvider';
import React, { useEffect, useRef } from 'react';

const OnlineUsers: React.FC = () => {
  const { emit } = useSocket();
  const tabId = useRef<string>(Math.random().toString(36).substring(2, 15));
  const isFirstTab = useRef<boolean>(false);

  useEffect(() => {
    const checkFirstTab = () => {
      const tabs = JSON.parse(localStorage.getItem('activeTabsList') || '[]');
      const newTabs = [...tabs, tabId.current];
      setTimeout(() => {
        if (!tabs.length) {
          emit('set_user_type');
        }
        localStorage.setItem('activeTabsList', JSON.stringify(newTabs));
      }, 2000);
    };

    // Xử lý khi tab đóng
    const handleBeforeUnload = () => {
      const tabs = JSON.parse(localStorage.getItem('activeTabsList') || '[]');
      tabs.pop();
      if (!tabs.length) {
        emit('disconnect_user_type');
        localStorage.removeItem('activeTabsList');
      } else {
        localStorage.setItem('activeTabsList', JSON.stringify(tabs));
      }
      // setTimeout(() => {
      // }, 2000);
    };

    checkFirstTab();
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      handleBeforeUnload();
    };
  }, []);

  return null;
};

export default OnlineUsers;
